<script lang="ts" setup>
import type { ContentResource } from '~/models/Content/ContentResource'

export interface DefaultComponentProps {
  props: ContentResource
  resources: ContentResource[]
  featured: ContentResource[]
}

const { resources } = defineProps<DefaultComponentProps>()
</script>

<template>
  <template
    v-for="item in resources"
    :key="item.locationId"
  >
    <slot
      name="resource"
      :resource-item="item"
    />
  </template>
</template>
